import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const LineaSelected = ({ value, onChange, className = "" }) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label-linea">Linea</InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-linea"
        id="demo-simple-select-linea"
        value={value}
        label="Linea"
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value={"TT"}>Consolidado</MenuItem>
        <MenuItem value={"MQ"}>Maquinaria Nueva</MenuItem>
        <MenuItem value={"UM"}>Maquinaria Seminueva</MenuItem>
        <MenuItem value={"MA"}>Productos Aliados</MenuItem>
        <MenuItem value={"MW"}>Sistemas de Riego</MenuItem>
        <MenuItem value={"SI"}>Soluciones Integrales</MenuItem>
        <MenuItem value={"GE"}>Garantia Extendida</MenuItem>
        <MenuItem value={"PM"}>Paquete de Mantenimiento</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LineaSelected;
